var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('page-header',{attrs:{"title":"New Route","breadcrumb":"Dashboard >> Settings >> Routes >> New Route"}}),_c('div',{staticClass:"mt-3 custom-card"},[_c('create-route-form',{attrs:{"states":_vm.states}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }